import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import '../styles/index.css';
import { AppRoutes } from './routes';
import { initTelegram } from '../lib/telegram';

const container = document.getElementById('root');
if (!container) {
  throw new Error('root element missing');
}

// Fire-and-forget — UI does not await SDK init; defensive wrapper handles failure.
void initTelegram();

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  </StrictMode>,
);
